import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Welcome from "@/pages/Welcome";
import Questionnaire from "@/pages/Questionnaire";
import Result from "@/pages/Result";
import AdminGate from "@/pages/AdminGate";
import AdminSetup from "@/pages/AdminSetup";
import AdminLogin from "@/pages/AdminLogin";
import AdminResetPassword from "@/pages/AdminResetPassword";
import AdminPrint from "@/pages/AdminPrint";
import AdminDashboard from "@/pages/AdminDashboard";
import ProtectedRoute from "@/pages/ProtectedRoute";
import TestModeBanner from "@/components/TestModeBanner";

export default function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Toaster position="top-center" richColors />
                <TestModeBanner />
                <Routes>
                    <Route path="/" element={<Welcome />} />
                    <Route path="/questionnaire" element={<Questionnaire />} />
                    <Route path="/resultat/:id" element={<Result />} />
                    <Route path="/admin" element={<AdminGate />} />
                    <Route path="/admin/setup" element={<AdminSetup />} />
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin/reset_password" element={<AdminResetPassword />} />
                    <Route path="/admin/print/:qid" element={<ProtectedRoute><AdminPrint /></ProtectedRoute>} />
                    <Route
                        path="/admin/dashboard/*"
                        element={
                            <ProtectedRoute>
                                <AdminDashboard />
                            </ProtectedRoute>
                        }
                    />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}
